
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Modification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Modification"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"modelId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bodyType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"driveType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fuelType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gearType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"power"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numOfCyl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numOfValves"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capacity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"platformType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"axleConfiguration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"suspensionTypes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"kbas"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hsn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tsn"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":281}};
    doc.loc.source = {"body":"fragment Modification on Modification {\n\tid\n\tname: title\n\tfullTitle\n\ttype\n\tmodelId\n\tstartDate\n\tendDate\n\tbodyType\n\tdriveType\n\tfuelType\n\tgearType\n\tpower\n\tnumOfCyl\n\tnumOfValves\n\tcapacity\n\tplatformType\n\taxleConfiguration\n\tsuspensionTypes {\n\t\tid\n\t\tname\n\t}\n\tkbas {\n\t\tid\n\t\thsn\n\t\ttsn\n\t}\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["Modification"] = oneQuery(doc, "Modification");
        
